import { render } from "./ChipList.vue?vue&type=template&id=2def43e4"
import script from "./ChipList.vue?vue&type=script&lang=js"
export * from "./ChipList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__